import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface FeeAcademicYear {
  pkAcademicId: string;
  Year: string;
  // 0 = currently active/current year, 1 = inactive/past year.
  InActive: 0 | 1;
}

export interface GetAcademicInfoResponse {
  status: boolean;
  message?: string;
  body?: {
    academicList: FeeAcademicYear[];
  };
}

export interface CollectedFeeMonth {
  monthYear: string;
  collectedAmount: number;
  collectedAmountWithLateFees: number;
}

export interface GetFeesInfoResponse {
  status: boolean;
  message?: string;
  body?: {
    collectedFeeData: CollectedFeeMonth[];
  };
}

// Same shape as CollectedFeeMonth (amount + late-fee amount for one time
// unit), but the backend names these fields differently for the day-wise
// drill-down than it does for the monthly overview.
export interface CollectedFeeDay {
  paymentDate: string;
  amountCollected: number;
  amountCollectedWithLateFees: number;
}

export interface GetMonthFeesInfoResponse {
  status: boolean;
  message?: string;
  body?: {
    collectedFeesDayWise: CollectedFeeDay[];
  };
}

@Injectable({ providedIn: 'root' })
export class StaffFeesService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getAcademicInfo(staffId: number | string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('lang', 'en');
    return this.http
      .get<GetAcademicInfoResponse>(this.url + apiConstants.getFeeCollectionAcademicIdList, { params })
      .pipe(map((res) => res));
  }

  getFeesInfo(staffId: number | string, academicId: number | string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('academicId', String(academicId))
      .set('lang', 'en');
    return this.http
      .get<GetFeesInfoResponse>(this.url + apiConstants.getFeeCollectionMonthlyCollectedFees, { params })
      .pipe(map((res) => res));
  }

  getMonthFeesInfo(staffId: number | string, academicId: number | string, monthNumber: number, yearNumber: number | string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('monthNumber', String(monthNumber))
      .set('yearNumber', String(yearNumber))
      .set('academicId', String(academicId))
      .set('lang', 'en');
    return this.http
      .get<GetMonthFeesInfoResponse>(this.url + apiConstants.getFeeCollectionDateWiseCollectedFees, { params })
      .pipe(map((res) => res));
  }
}
